import type { GraphNode } from 'features/knowledgeDocumentViewer/graph/graphTypes'
import type { GraphTransport } from 'features/knowledgeDocumentViewer/graph/loadPageGraph'
import {
  loadNodePageDestinations,
  type PageDestination,
} from 'features/knowledgeDocumentViewer/graph/nodePageDestinations'

export async function loadOffPageConnectorPageDestination(
  target: GraphNode,
  load: GraphTransport
): Promise<PageDestination> {
  const destinations = await loadNodePageDestinations(
    target.id,
    target.tags,
    load
  )
  if (destinations.length !== 1)
    throw new Error('Off-page connector page was not uniquely resolved')
  return destinations[0]
}
